import SingleChoiceClosedQuestion from 'models/common/form/question/SingleChoiceClosedQuestion';

import ClosedQuestionService from 'services/common/form/question/ClosedQuestionService';

export default class SingleChoiceClosedQuestionService extends ClosedQuestionService {
	toModel(question) {
		return new SingleChoiceClosedQuestion(super.toModel(question));
	}
}
